import { useCallback, useState } from "react";

import { useAppContext } from "@components/AppContext";

import type { AppContext } from "../../types";

type UseDeleteOptions = {
  scheduleId?: string;
  deleteSchedule: (scheduleId: string) => Promise<unknown>;
  onClose: () => void;
};

const useDelete = ({
  scheduleId,
  deleteSchedule,
  onClose,
}: UseDeleteOptions) => {
  const [ isDeleting, setIsDeleting ] = useState(false);
  const { showErrorMessage } = useAppContext() as AppContext;

  const onDeleteSchedule = useCallback(async () => {
    if (!scheduleId) {
      return;
    }

    setIsDeleting(true);

    try {
      await deleteSchedule(scheduleId);
      onClose();
    } catch (error) {
      showErrorMessage(error instanceof Error ? error.message : String(error));
    } finally {
      setIsDeleting(false);
    }
  }, [ deleteSchedule, onClose, scheduleId, showErrorMessage ]);

  return { onDeleteSchedule, isDeleting };
};

export default useDelete;
